/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Controller, FormProvider, useForm} from 'react-hook-form'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {SelectWrapper, InputDateWrapper} from '../../../../../components/UI/Form/Input'
import {SelectOption} from '../../../../../models/utility.model'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {ValuationHeaderReportDTO} from '../../../models/reports.model'
import {yupResolver} from '@hookform/resolvers/yup'
import {reportValuationSchema} from '../../../../../util/validationHoteleria'
import {getReportValuationExcel, getReportValuationList} from '../../../services/report.service'
import {TableCostsWrapper} from './Tables/TableValuation'
import moment from 'moment'
import {useAuth} from '../../../../../hooks/useAuth'
import {getFactConfigByValueId} from '../../../../central/services/configFacturation.service'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import {ShowSnackBar} from '../../../../../util/functions'
const ReportValoration: FC = () => {
  const {currentTabItem} = useHoteleria()
  const {user} = useAuth()
  const methods = useForm<any>({
    resolver: yupResolver(reportValuationSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      fechaFin: '',
      fechaInicio: '',
      mesCompleto: false,
    },
  })

  const {setValue, handleSubmit, setError, control, watch} = methods
  const [loading, setLoading] = useState(false)
  const [arrayDates, setArrayDates] = useState([])
  const [data, setData] = useState([])
  const [rangeDay, setRangeDay] = useState<number | string>(0)
  const [company, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [sites, setSites] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [loadingExport, setLoadingExport] = useState(false)

  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
      await getValuesDays(data[0].value as string)
    }
    setSites(data)
  }

  const getCampsFn = async (SiteId: string) => {
    const data = await getCamps({isCombo: true, siteId: SiteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [{value: '4EsB2NAAsDA=', label: 'TODOS'}, ...data]
    setCamps(allData)
  }

  const getValuesDays = async (id: string) => {
    try {
      const {data} = await getFactConfigByValueId(
        id,
        watch('ClienteId'),
        user.applicationId,
        currentTabItem.vistaId,
      )
      if (!data.error) {
        setRangeDay(data.data.ValorInicio as string)
      }
    } catch (error) {
      console.log('error', error)
    }
  }
  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})
    getClientsFn(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSitesFn(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    getCampsFn(value)
    getValuesDays(value)
  }

  const handleClear = () => {
    setValue('CompaniaId', '')
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('mesCompleto', false)
    setValue('valorizado', false)
    setValue('fechaInicio', '')
    setValue('fechaFin', '')
    setClient([])
    setSites([])
    setCamps([])
    setData([])
    setArrayDates([])
  }

  const onSubmit = async (dataForm: ValuationHeaderReportDTO) => {
    setLoading(true)
    dataForm.fechaFin = dataForm.fechaFin ? dataForm.fechaFin.replaceAll('-', '/') : null
    dataForm.fechaInicio = dataForm.fechaInicio ? dataForm.fechaInicio.replaceAll('-', '/') : null
    dataForm.aplicacionId = user.applicationId
    try {
      const resp = await getReportValuationList(dataForm)
      if (resp.data.detail.length === 0) {
        ShowSnackBar('NO HAY INFORMACIÓN', 'success')
      }
      const fechasConId = resp.data.detail[0].items.map((item) => {
        const fecha = new Date(item.fecha)
        const day = String(fecha.getDate()).padStart(2, '0')
        const month = String(fecha.getMonth() + 1).padStart(2, '0')
        return {
          id: `C${day}${month}`,
          fecha: item.fecha,
        }
      })
      setArrayDates(fechasConId)
      const transformed = resp.data.detail.map((det) => {
        const newEntry = {
          tipoOperacion: det.tipoOperacion,
          cantidadPromedio: det.cantidadPromedio,
        }

        det.items.forEach((item) => {
          const fecha = new Date(item.fecha)
          const day = String(fecha.getDate()).padStart(2, '0')
          const month = String(fecha.getMonth() + 1).padStart(2, '0')
          const key = `C${day}${month}`
          newEntry[key] = item.cantidad
        })

        return newEntry
      })
      const lastDateId = fechasConId[fechasConId.length - 2]?.id // Obtener el último Cxx
      const totalColumnKey = `${lastDateId}`
      const lastRow = {
        isSpecialRow: true,
        tipoOperacion: '',
        cantidadPromedio: resp.data.promedioGeneral,
        [totalColumnKey]: 'Promedio General Mensual',
        groupConfig: {startIndex: fechasConId.length - 1, count: 2},
      }
      transformed.push(lastRow)
      setData(transformed)
    } catch (error) {
      console.log({error})
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    setLoadingExport(true)
    try {
      const response = await getReportValuationExcel({
        ...methods.watch(),
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reporte-Valoracion-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.log({error})
    } finally {
      setLoadingExport(false)
    }
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChangeMesCompleto = (e: any) => {
    if (e.target.checked) {
      setValue('fechaInicio', '')
      setError('fechaInicio', {})
      setValue('fechaFin', '')
      setError('fechaFin', {})
    }
  }
  const handleChangeRangeDate = (e: any) => {
    const value = e.target.value
    if (value) {
      let addDays = moment(value).add(rangeDay, 'days')
      setValue('fechaFin', addDays.format('YYYY-MM-DD'))
    } else {
      setValue('fechaFin', '')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Compañia'
                    name='CompaniaId'
                    data={company}
                    onChangeValue={handleCompanyChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Cliente'
                    name='ClienteId'
                    data={client}
                    onChangeValue={handleClientChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Site'
                    name='SiteId'
                    data={sites}
                    onChangeValue={handleSiteChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper labelText='Campamento' name='CampamentoId' data={camps} required />
                </div>
              </div>
              <div className='row'>
                {!watch('mesCompleto') && (
                  <>
                    <div className='col-sm-12 col-lg-3'>
                      <InputDateWrapper
                        labelText='Nro Día Inicio'
                        name='fechaInicio'
                        required
                        onChange={handleChangeRangeDate}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <InputDateWrapper labelText='Nro Día Fin' name='fechaFin' required />
                    </div>
                  </>
                )}

                <div className='col-sm-12 col-lg-3'>
                  <label className=''>Mes Completo</label>
                  <div className='sdx_form_input'>
                    <div className='form-check form-switch form-check-custom form-check-solid'>
                      <Controller
                        name={'mesCompleto'}
                        control={control}
                        render={({field}) => {
                          return (
                            <input
                              className='form-check-input'
                              type='checkbox'
                              checked={field?.value}
                              onChange={(e) => {
                                field.onChange(e)
                                handleChangeMesCompleto(e)
                              }}
                            />
                          )
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className=''>Valorizado</label>
                  <div className='sdx_form_input'>
                    <div className='form-check form-switch form-check-custom form-check-solid'>
                      <Controller
                        name={'valorizado'}
                        control={control}
                        render={({field}) => (
                          <input
                            className='form-check-input'
                            type='checkbox'
                            id='switchActivaExpresion'
                            checked={field?.value}
                            onChange={(e) => {
                              field.onChange(e)
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button
                  label='Buscar'
                  onClick={handleSubmit(onSubmit)}
                  loading={loading}
                  disabled={loading}
                />
                <Button label='Limpiar' onClick={handleClear} />
                <Button
                  label='Exportar'
                  onClick={handleExport}
                  typeBtn='button'
                  disabled={data.length === 0 || loadingExport}
                  loading={loadingExport}
                />
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        {data.length > 0 && (
          <TableCostsWrapper arrayDates={arrayDates} data={data} loading={loading} />
        )}
      </KTCard>
    </>
  )
}

export {ReportValoration}
